export const AUTH_MODAL_STORAGE_KEY = 'fleep:open-auth-modal';

export const rememberOpenAuthModal = (tab = 'login') => {
    if (typeof window !== 'undefined') {
        sessionStorage.setItem(AUTH_MODAL_STORAGE_KEY, tab);
    }
};

export const forgetOpenAuthModal = () => {
    if (typeof window !== 'undefined') {
        sessionStorage.removeItem(AUTH_MODAL_STORAGE_KEY);
    }
};

export const readPendingAuthModalTab = () => {
    if (typeof window === 'undefined') {
        return null;
    }
    const auth = sessionStorage.getItem(AUTH_MODAL_STORAGE_KEY);
    return auth === 'login' || auth === 'register' ? auth : null;
};

export const redirectToAuthLanding = (tab = 'login') => {
    rememberOpenAuthModal(tab);
    window.location.href = `/?auth=${tab}`;
};
